import {inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import * as fromMessageActions from '../actions/message.actions';
import {catchError, map, switchMap} from 'rxjs/operators';
import {MessageRestService} from '../../services/api/message/message-rest.service';

@Injectable()
export class MessageEffects {
    private actions$ = inject(Actions);
    private messageService = inject(MessageRestService);
    
    initMessages$ = createEffect(() =>
        this.actions$.pipe(
            ofType<fromMessageActions.InitMessagesAction>(
                fromMessageActions.MessageActionTypes.INIT_MESSAGES
            ),
            map(action => action),
            switchMap(() =>
                this.messageService.initMessages().pipe(
                    map(data => new fromMessageActions.InitMessagesCompleteAction(data.returnObject)),
                    catchError(error => of(new fromMessageActions.ErrorAction(error)))
                )
            )
        )
    );

    loadMessages$ = createEffect(() =>
        this.actions$.pipe(
            ofType<fromMessageActions.LoadMessagesAction>(
                fromMessageActions.MessageActionTypes.LOAD_MESSAGES
            ),
            map(action => action.payload),
            switchMap(rq =>
                this.messageService.loadMessages(rq).pipe(
                    map(data => new fromMessageActions.LoadMessagesCompleteAction(data.returnObject)),
                    catchError(error => of(new fromMessageActions.ErrorAction(error)))
                )
            )
        )
    );

    loadMessage$ = createEffect(() =>
        this.actions$.pipe(
            ofType<fromMessageActions.LoadMessageAction>(
                fromMessageActions.MessageActionTypes.LOAD_MESSAGE
            ),
            map(action => action),
            switchMap(rq =>
                this.messageService.loadMessage(rq).pipe(
                    map(data => new fromMessageActions.LoadMessageCompleteAction(data.returnObject)),
                    catchError(error => of(new fromMessageActions.ErrorAction(error)))
                )
            )
        )
    );

}